/* src/app/components/case/contacts/case-contact-edit/case-contact-edit.component.scss */
.row {
  padding-bottom: 15px;
}
/*# sourceMappingURL=case-contact-edit.component.css.map */
